import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, debounceTime, distinctUntilChanged, of, Subject, switchMap } from 'rxjs';
import { ArticleService } from 'src/app/services/article.services';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { CartService } from 'src/app/services/cart.services';
import { ScriptLoaderService } from 'src/app/services/script-loader.services';
import { WishlistService } from 'src/app/services/wishlist.service';
declare var bootstrap: any;

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {

cartItems: any[] = [];
  quantity: number = 1;
  article: any;
  wishlistCount: number = 0;
  cartCount: number = 0;

articles: any[] = [];
showResults: boolean = false;
searchQuery: string = '';
searchQuerySubject: Subject<string> = new Subject<string>();

selectedCategorie: number | null = null; // si tu veux filtrer par catégorie


  constructor(private cartService :CartService, private router: Router, private articlesService: ArticleService, private scriptLoader: ScriptLoaderService,private authService: AuthServiceService,private wishlist : WishlistService) { }

  ngOnInit(): void {

    this.loadCartItems();
    this.cartService.cart$.subscribe(cart => {
      this.cartItems = cart;
      this.cartCount = cart.reduce((total, item) => total + item.quantity, 0);
    });

    this.wishlist.wishlist$.subscribe(wishlist => {
      this.wishlistCount = this.wishlist.getWishlistCount();
    });
    this.searchQuerySubject.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((query) => {
        if (query.trim() === '') {
          this.showResults = false;
          this.articles = [];
          return of([]);
        }

        const requestBody = {
          search: query.trim(),
          id_categorie: this.selectedCategorie ? +this.selectedCategorie : 0
        };

        console.log('🔎 Recherche instantanée avec :', requestBody);

        return this.articlesService.searchArticles(requestBody).pipe(
          catchError((error) => {
            console.error('❌ Erreur recherche :', error);
            return of([]);
          })
        );
      })
    ).subscribe((results: any[]) => {
      this.articles = results;
      this.showResults = this.searchQuery.trim() !== '';
      console.log('✅ Résultats recherche :', this.articles);
    });
  }
  performInstantSearch(): void {
    this.searchQuerySubject.next(this.searchQuery || '');
  }

  loadCartItems(): void {
    this.cartItems = this.cartService.getCartItems();
  }
  goToCart(): void {
    this.closeShoppingCartModal();
    this.router.navigate(['/cart']);
  }

  goToCheckout(): void {
    this.closeShoppingCartModal();
    this.router.navigate(['/checkout']);
  }

  closeShoppingCartModal(): void {
    document.addEventListener('hidden.bs.modal', () => {
      setTimeout(() => {
        const backdrops = document.querySelectorAll('.modal-backdrop');
        const anyOpen = document.querySelector('.modal.show');

        // Supprime les backdrops s'il n'y a plus de modals ouverts
        if (!anyOpen) {
          backdrops.forEach(b => b.remove());
          document.body.classList.remove('modal-open');
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';
        }
      }, 200); // attendre que Bootstrap fasse son animation
    });
  }



  navigateToSearchPage(): void {
    if (this.searchQuery.trim()) {
      this.router.navigate(['/search'], { queryParams: { q: this.searchQuery } });
    }
  }

  goToProduct(articleId: number, libelle: string): void {
    if (!articleId || !libelle) {
      console.error("Erreur : ID ou libellé manquant !");
      return;
    }

    // 👉 Fermer le offcanvas (Bootstrap 5)
    const offcanvasElement = document.getElementById('canvasSearch');
    if (offcanvasElement) {
      const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasElement) || new bootstrap.Offcanvas(offcanvasElement);
      bsOffcanvas.hide();
    }

    const formattedLibelle = libelle.toLowerCase().replace(/ /g, '-');
    const url = `/singleproduct/${formattedLibelle}/${articleId}`;
    console.log("Navigating to:", url);
    this.router.navigate([url]);
  }

  getRemainingForFreeShipping(): number {
    const threshold = 99;
    const currentTotal = this.getCartTotal();
    return Math.max(0, threshold - currentTotal);
  }
  goToAccount(event: Event): void {
    event.preventDefault(); // évite le rechargement

    if (this.authService.getClientId() !== null) {
      this.router.navigate(['/account']);
    } else {
      this.router.navigate(['/login']);
    }
  }
  getCartTotal(): number {
    const total = this.cartItems.reduce((total, item) => {
      const price = item.promo !== 0 ? item.prix_final : item.prix_ttc;
      const itemTotal = price * item.quantity;
      return total + itemTotal;
    }, 0);
    return total;
  }
  increaseQuantity(article: any): void {
    this.quantity++; // Incrémente directement la valeur
    this.updateTotalPrice(article);
  }

  // Décrémente la quantité (minimum 1)
  decreaseQuantity(article: any): void {
    if (this.quantity > 1) {
      this.quantity--; // Décrémente si > 1
      this.updateTotalPrice(article);
    }
  }

  // Met à jour le prix total
  updateTotalPrice(article: any): void {
    article.totalPrice = this.quantity * article.prix_ttc;
  }
}
